import ReactDOM from "react-dom/client"

import App from "./App"

import { AuthContextProvider } from "./context/AuthContext"
import { SessionProvider } from "./context/SessionContext"
import AppErrorBoundary from "./component/commonUnit/AppErrorBoundary"

import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <AppErrorBoundary>
    <AuthContextProvider>
      <SessionProvider>
        {/* <React.StrictMode> */}
          <App />
        {/* </React.StrictMode> */}
      </SessionProvider>
    </AuthContextProvider>
  </AppErrorBoundary>
)

reportWebVitals()